import User from '@/classes/users/User'

export default class Users extends Array {
  constructor (users, ...rest) {
    Array.isArray(users) ? super(...users.map(user => new User(user))) : super(...rest)
  }

  isProjectAdmin (authUser) {
    return this.find(user => user.id === authUser.id && user.role === 'admin') || authUser.is_koalect || authUser.is_super_admin
  }
}
